.geoMap {
  position: relative;
  width: 100%;
  height: 100%;
  grid-column: 2;
  grid-row: 2;
}

.infoMessageContainer {
  position: absolute;
  bottom: var(--spacing-32);
  right: var(--spacing-24);
  z-index: 50;
  max-width: 500px;
  pointer-events: all;

  .pointList {
    display: flex;
    flex-direction: column;

    .point {
      display: flex;
      align-items: center;
      column-gap: var(--spacing-08);
    }

    .bullet {
      display: block;
      height: 6px;
      width: 6px;
      background-color: var(--sparky-blue-400);
      border-radius: 100%;
    }
  }
}
